import React from 'react';
import ChartSkill from "./skill.js";
import AdditionalSkill from "./aditionalSkill";
import TickSkill from "./tickSkill";
const SkillsCharts = () => (
    <section className="section-c skills-charts-section">
        <div className="section-title">
            <h2>Skills </h2>
        </div>
        <div className="charts-wrapper">
            <div className="chart technologies-chart">
                <div className="chart__title">
                    Technologies
                </div>
                <div className="chart__contents">
                    <ChartSkill name="HTML & CSS" value="90" info="2 years experience" />
                    <ChartSkill name="Angular" value="70" info="2 years experience" />
                    <ChartSkill name="Ionic" value="75" info="2 years experience" />
                    <ChartSkill name="React" value="50" info="2 years experience" />
                    <ChartSkill name="Node JS" value="70" info="2 years experience" />
                    <ChartSkill name="AngularJS" value="70" info="2 years experience" />
                    <ChartSkill name="Vue" value="40" info="2 years experience" />
                    <ChartSkill name="TypeScript" value="70" info="2 years experience" />
                    <ChartSkill name="Java" value="60" info="2 years experience" />
                    <ChartSkill name="Swift" value="50" info="2 years experience" />
                    <ChartSkill name="React Native" value="45" info="2 years experience" />
                    <ChartSkill name="Photoshop" value="70" info="2 years experience" />
                </div>
            </div>
            <div className="chart additional-chart">
                <div className="chart__title">
                    Additional Skills
                </div>
                <div className="chart__contents">
                    <div className="round-progress-skills">
                        <AdditionalSkill title="Multitasker" value="90"></AdditionalSkill>
                        <AdditionalSkill title="Creative" value="85"></AdditionalSkill>
                        <AdditionalSkill title="Team player" value="85"></AdditionalSkill>
                        <AdditionalSkill title="Fast Learner" value="90"></AdditionalSkill>
                    </div>
                    <div className="skills-list">
                        <TickSkill name="DevOps"></TickSkill>
                        <TickSkill name="API Design"></TickSkill>
                        <TickSkill name="REST APIs"></TickSkill>
                        <TickSkill name="Docker"></TickSkill>
                        <TickSkill name="MongoDB"></TickSkill>
                        <TickSkill name="ExpressJS"></TickSkill>
                        <TickSkill name="Socket.io"></TickSkill>
                        <TickSkill name="Adobe Creative Cloud"></TickSkill>
                        <TickSkill name="Version Control"></TickSkill>
                        <TickSkill name="Microservices Architecture"></TickSkill>
                        <TickSkill name="AWS"></TickSkill>
                        <TickSkill name="Digital Ocean"></TickSkill>
                        <TickSkill name="SASS"></TickSkill>
                        <TickSkill name="Firebase"></TickSkill>
                        <TickSkill name="Heroku"></TickSkill>
                        <TickSkill name="Redis"></TickSkill>
                        <TickSkill name="Facebook Ads"></TickSkill>
                        <TickSkill name="Agile Software Development"></TickSkill>
                    </div>
                </div>

            </div>
        </div>
    </section>
);

export default SkillsCharts;


// WEBPACK FOOTER //
// ./src/components/skills/Charts/index.js